import React, { useEffect } from "react";
import "../../styles/home.css";
import "../../styles/form.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    logout().then(() => {
      navigate("/");
    });
  }, [logout, navigate]);

  return <div>Logging out...</div>;
};

Logout.propTypes = {};

export default Logout;
